import React, { lazy, Suspense } from 'react';

import styles from './reportingWrapper.module.scss';

const CompaniesWrapper = lazy(() => import("./modules/Companies"));
const ProjectsWrapper = lazy(() => import("./modules/Projects"));
const IdeasWrapper = lazy(() => import("./modules/Ideas"));

const ReportingWrapper = () => {
  return (
    <div className={styles.reportingContainer}>
      <div className={styles.reportSections}>
        <Suspense fallback="Loading...">
          <CompaniesWrapper />
          <hr className="mb-5" />
          <ProjectsWrapper />
          <hr className="mb-5" />
          <IdeasWrapper />
        </Suspense>
      </div>
    </div>
  );
};

export default React.memo(ReportingWrapper);
